// Support docs opened from the Player Finder header help ("?") icon.
export const PLAYER_FINDER_SUPPORT_URL =
  'https://support.sportninja.com/player-finder'

/**
 * Currency shown beside a finder preference's charge rate. The API stores
 * `charge_rate` as a bare number with no currency of its own, so this is the
 * single place to change the symbol if per-currency rates ever ship.
 */
export const RATE_CURRENCY_SYMBOL = '$'
